import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import styled from 'react-emotion';

import { ALL_CATEGORIES } from '../../../constants/events';
import { ALERT_BANNERS } from '../../../constants/alertBanners';
import EventCard from './EventCard/EventCard';
import EventDateTitle from './EventDateTitle/EventDateTitle';
import { fetchEvents } from '../../../redux/actions/events';
import { getEventsByDayState } from '../../../redux/reducers/events';
import Spinner from '../../../components/Spinner/Spinner';
import Style from '../../../styles/common';

const Container = styled('div')`
  margin-bottom: ${Style.SPACING.M};
  width: 100%;
`;

const SpinnerContainer = styled('div')`
  margin: ${Style.SPACING.XXL} 0;
`;

class Events extends Component {
  static propTypes = {
    activeCategory: PropTypes.object,
    events: PropTypes.arrayOf(PropTypes.object),
    hasMore: PropTypes.bool,
    isBannerVisible: PropTypes.bool,
    isRequesting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    activeCategory: ALL_CATEGORIES,
    events: [],
    hasMore: true,
    isBannerVisible: false,
  };

  componentDidMount() {
    this.props.fetchEvents();
  }

  render() {
    const isLoadingInitial = this.props.events.length === 0 && this.props.isRequesting;
    // Cannot mount InfiniteScroll immediately or else will request events twice
    // For some reason switching category makes it think bottom is hit, but
    // on initial load it cannot detect bottom hit
    // https://github.com/ankeetmaini/react-infinite-scroll-component/issues/47
    const body = isLoadingInitial ? Events.spinner : (
      <InfiniteScroll
        dataLength={this.props.events.length}
        hasMore={this.props.hasMore}
        loader={Events.spinner}
        next={this.props.fetchEvents}
      >
        {this.events}
      </InfiniteScroll>
    );
    return (
      <Container>{body}</Container>
    );
  }

  static get spinner() {
    return (
      <SpinnerContainer>
        <Spinner message="Fetching events..." />
      </SpinnerContainer>
    );
  }

  get events() {
    const offset = Style.MEASUREMENT.CATEGORY_NAV.HEIGHT;

    return this.props.events.map(day => {
      const date = day.events.length ? (
        <EventDateTitle
          date={day.startDate}
          key={day.startDate}
          offset={offset}
        />
      ) : null;
      const events = day.events.map((event) => {
        return (
          <EventCard
            id={event.id}
            imageUrl={event.poster.url}
            key={event.id}
            location={event.location}
            startDateTime={event.startDateTime}
            title={event.title}
          />
        )
      });
      return [date, ...events];
    });
  }
}

export default connect(
  state => ({
    activeCategory: state.activeCategory,
    events: getEventsByDayState(state),
    hasMore: state.events.hasMore,
    isBannerVisible: state.alertBanner[ALERT_BANNERS.BETA],
    isRequesting: state.events.isRequesting,
  }),
  { fetchEvents },
)(Events);



// WEBPACK FOOTER //
// ./src/views/Browse/Events/Events.js